import hostDialogs from "./host-dialogs/lang.en";
import hostTeamlessInbox from "./host-teamless-inbox/lang.en";

export default {
	"host-dialogs": hostDialogs,
	"host-teamless-inbox": hostTeamlessInbox,
};
